import "./Project1.css";
function Project1() {
  return (
    <div className="project1-cont active">
      <div className="project-header">
        <h2>1 Mill Street</h2>
      </div>
      <div className="about-text">
        <p>
          1 Mill Street is an innovative custom theme with various custom blocks developed for a modern co-working and hospitality hub. The website has a sleek and user-friendly interface, providing potential clients with an immersive visual experience. The project was implemented using PHP, ACF, CSS, SASS, WordPress, JavaScript, and jQuery.
          <br/>
          1 Mill Street was developed under the expert supervision and creative direction of Up Hotel Agency.
        </p>
        <h3 className="project-link">
          <a
            href="https://www.1millstreet.com/"
            target="_blank"
            rel="noreferrer"
          >
            <span>View Site</span>
          </a>
          <br />
        </h3>
      </div>
    </div>
  );
}

export default Project1;
